import script from "./CountrySelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountrySelect.vue?vue&type=script&setup=true&lang=ts"

import "./CountrySelect.vue?vue&type=style&index=0&id=cff5f648&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cff5f648"]])

export default __exports__